export const carouselImages = [
    {
        "imagen" : "../assets/imgs/cuartel.jpg"
    },
    {
        "imagen" : "../assets/imgs/fondo_banner.png"
    },
    /*{
        "imagen" : "https://cdn.hidalgo.gob.mx/gobierno/images/veda/banner_veda.png"
    },*/
    {
        "imagen" : "../assets/imgs/banner1.jpg"
    }
]